(() => {
  const propertyName = '--snusbox-announcement-height';
  const selector = '.announcement-bar-section .utility-bar';
  let observer;

  const measure = () => {
    const bar = document.querySelector(selector);
    const height = bar && getComputedStyle(bar).display !== 'none'
      ? Math.ceil(bar.getBoundingClientRect().height)
      : 0;

    document.documentElement.style.setProperty(propertyName, `${height}px`);
  };

  const connect = () => {
    if (observer) observer.disconnect();

    const bar = document.querySelector(selector);
    if (!bar) {
      document.documentElement.style.setProperty(propertyName, '0px');
      return;
    }

    observer = new ResizeObserver(measure);
    observer.observe(bar);
    measure();

    if (document.fonts) {
      document.fonts.ready.then(measure);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }

  document.addEventListener('shopify:section:load', connect);
  window.addEventListener('pageshow', measure);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', measure);
  }
})();